// extracted by mini-css-extract-plugin
export default {"sidePanel":"fpaF9Y"};